/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateWorkflowForApplicationRequest } from '../models/CreateWorkflowForApplicationRequest';
import type { CreateWorkflowRequest } from '../models/CreateWorkflowRequest';
import type { FormResponseDto } from '../models/FormResponseDto';
import type { GetHousingApplicationsWithActivitiesResponseDto } from '../models/GetHousingApplicationsWithActivitiesResponseDto';
import type { HousingApplication } from '../models/HousingApplication';
import type { HousingApplicationDrawerDataDto } from '../models/HousingApplicationDrawerDataDto';
import type { HousingApplicationDto } from '../models/HousingApplicationDto';
import type { HousingApplicationSource } from '../models/HousingApplicationSource';
import type { HousingApplicationStatus } from '../models/HousingApplicationStatus';
import type { HousingIntakeScenarioStatus } from '../models/HousingIntakeScenarioStatus';
import type { HousingSiteResult } from '../models/HousingSiteResult';
import type { LinkedPersonDto } from '../models/LinkedPersonDto';
import type { SearchHousingApplicationsForListResponseDto } from '../models/SearchHousingApplicationsForListResponseDto';
import type { SearchHousingApplicationsResponseDto } from '../models/SearchHousingApplicationsResponseDto';
import type { SearchVacancyApplicationsResponseDto } from '../models/SearchVacancyApplicationsResponseDto';
import type { SetPrimaryContactRequest } from '../models/SetPrimaryContactRequest';
import type { UpdateHousingApplicationRequestDto } from '../models/UpdateHousingApplicationRequestDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingApplicationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all housing applications in the DB.
     * If attempting to get only your applications, userGuid should be null.
     * @param sysOrgGuid
     * @param statusList Filter by status
     * @param userGuid Filter to the selected user's applications
     * @param includeArchived true to include archived applications
     * @returns HousingApplicationDto OK
     * @throws ApiError
     */
    public getHousingApplications(
        sysOrgGuid: string,
        statusList?: Array<HousingApplicationStatus>,
        userGuid?: string,
        includeArchived: boolean = false,
    ): CancelablePromise<Array<HousingApplicationDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/{sysOrgGuid}/GetHousingApplications',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            query: {
                'statusList': statusList,
                'userGuid': userGuid,
                'includeArchived': includeArchived,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Paginated housing application list with full server-side filtering.
     * Supports:
     * - Text search (name, app#, email, phone)
     * - Ownership filters (assigned/created by, mine/myOrg/anyone/custom)
     * - Status, HMB, unit type, pet, accessible, archived filters
     * - Date range on DateCreated or DateSubmitted
     * - Pagination
     * @param sysOrgGuid
     * @param applicantNameSearch Searches ApplicantName and CoApplicantName (word-order independent, AND logic,
     * quoted tokens require whole-word match).
     * @param coApplicantNameSearch Searches CoApplicantName — frontend sends same value as ApplicantNameSearch.
     * @param applicationNumberSearch Searches ApplicationNumber. Plain number → prefix match. Quoted → exact match.
     * @param emailSearch Searches Person.PrimaryEmail via HousingApplicationPersons.
     * Quoted → exact match. Unquoted → contains.
     * @param phoneSearch Searches Person.PrimaryPhone (digits-only comparison).
     * Quoted → exact digit match. Unquoted → digit sequence contained.
     * Minimum 3 digits required.
     * @param idSearch Searches Application GUID.
     * @param quickFilter "mine" | "myOrg" | "anyone" | "custom".
     * Resolved server-side using AssignedToUserGuids / CreatedByUserGuids.
     * @param assignedToUserGuids Filter to applications assigned to any of these users.
     * @param createdByUserGuids Filter to applications created by any of these users.
     * @param personInclude Which person axis to include: "assigned" | "created" | "both".
     * This mirrors the UI PersonInclude and helps the server interpret
     * QuickFilter == "anyone" when the frontend did not supply explicit
     * GUID lists.
     * @param ignoreFilters When true all ownership / status / date filters are ignored;
     * only text search and IncludeArchived still apply.
     * @param includeStatusFilter When true all status filters are included.
     * @param statuses Filter to specific statuses. Empty = all statuses.
     * @param includeArchived
     * @param hmbCode Filter to applications with a PREFERRED site selection in this HMB org code.
     * @param unitTypeCode Filter to applications with a PREFERRED site selection for this unit type code.
     * @param dateField "created" (DateCreated) or "submitted" (DateSubmitted). Defaults to "created".
     * @param dateFrom
     * @param dateTo
     * @returns SearchHousingApplicationsForListResponseDto OK
     * @throws ApiError
     */
    public searchHousingApplicationsForList(
        sysOrgGuid: string,
        applicantNameSearch?: string,
        coApplicantNameSearch?: string,
        applicationNumberSearch?: string,
        emailSearch?: string,
        phoneSearch?: string,
        idSearch?: string,
        quickFilter?: string,
        assignedToUserGuids?: Array<string>,
        createdByUserGuids?: Array<string>,
        personInclude?: string,
        ignoreFilters?: boolean,
        includeStatusFilter?: boolean,
        statuses?: Array<HousingApplicationStatus>,
        includeArchived?: boolean,
        hmbCode?: string,
        unitTypeCode?: string,
        dateField?: string,
        dateFrom?: string,
        dateTo?: string,
    ): CancelablePromise<SearchHousingApplicationsForListResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/{sysOrgGuid}/SearchHousingApplicationsForList',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            query: {
                'ApplicantNameSearch': applicantNameSearch,
                'CoApplicantNameSearch': coApplicantNameSearch,
                'ApplicationNumberSearch': applicationNumberSearch,
                'EmailSearch': emailSearch,
                'PhoneSearch': phoneSearch,
                'IDSearch': idSearch,
                'QuickFilter': quickFilter,
                'AssignedToUserGuids': assignedToUserGuids,
                'CreatedByUserGuids': createdByUserGuids,
                'PersonInclude': personInclude,
                'IgnoreFilters': ignoreFilters,
                'IncludeStatusFilter': includeStatusFilter,
                'Statuses': statuses,
                'IncludeArchived': includeArchived,
                'HmbCode': hmbCode,
                'UnitTypeCode': unitTypeCode,
                'DateField': dateField,
                'DateFrom': dateFrom,
                'DateTo': dateTo,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Paginated, server-side search/filter endpoint for housing applications.
     * Supports text search, quick-filter presets (mine / myOrg / all / custom),
     * status filtering, and pagination.
     * @param search Free-text search against application details (searches all fields).
     * Use the field-specific params below for targeted search instead.
     * @param nameSearch
     * @param appNumberSearch
     * @param emailSearch
     * @param phoneSearch
     * @param quickFilter s
     * Quick-filter preset. "mine" = created by the calling user,
     * "myOrg" = orgs the calling user has roles in,
     * "all" = no ownership filter,
     * "custom" = use Compliance.Module.Housing.Dtos.SearchHousingApplicationsRequestDto.HousingOrgGuid and/or Compliance.Module.Housing.Dtos.SearchHousingApplicationsRequestDto.CreatedByGuid.
     * @param housingOrgGuid Filter by housing org (used when QuickFilter is "custom").
     * @param createdByGuid Filter by application creator (used when QuickFilter is "custom").
     * @param statuses Statuses to include. When empty or null, no status filter is applied.
     * Archived applications are controlled by Compliance.Module.Housing.Dtos.SearchHousingApplicationsRequestDto.IncludeArchived.
     * @param scenarioStatuses Scenario statuses to include.
     * @param includeArchived Whether to include archived applications.
     * @param ignoreFilters When true, only the text search is applied and all other filters are ignored.
     * Matches the "Search All" UX pattern.
     * @param pageNumber
     * @param pageSize
     * @returns SearchHousingApplicationsResponseDto OK
     * @throws ApiError
     */
    public searchHousingApplications(
        search?: string,
        nameSearch?: string,
        appNumberSearch?: string,
        emailSearch?: string,
        phoneSearch?: string,
        quickFilter?: string,
        housingOrgGuid?: string,
        createdByGuid?: string,
        statuses?: Array<HousingApplicationStatus>,
        scenarioStatuses?: Array<HousingIntakeScenarioStatus>,
        includeArchived?: boolean,
        ignoreFilters?: boolean,
        pageNumber?: number,
        pageSize?: number,
    ): CancelablePromise<SearchHousingApplicationsResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/SearchHousingApplications',
            query: {
                'Search': search,
                'NameSearch': nameSearch,
                'AppNumberSearch': appNumberSearch,
                'EmailSearch': emailSearch,
                'PhoneSearch': phoneSearch,
                'QuickFilter': quickFilter,
                'HousingOrgGuid': housingOrgGuid,
                'CreatedByGuid': createdByGuid,
                'Statuses': statuses,
                'ScenarioStatuses': scenarioStatuses,
                'IncludeArchived': includeArchived,
                'IgnoreFilters': ignoreFilters,
                'PageNumber': pageNumber,
                'PageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param search Free-text search against application details (searches all fields).
     * Use the field-specific params below for targeted search instead.
     * @param nameSearch
     * @param appNumberSearch
     * @param emailSearch
     * @param phoneSearch
     * @param quickFilter s
     * Quick-filter preset. "mine" = created by the calling user,
     * "myOrg" = orgs the calling user has roles in,
     * "all" = no ownership filter,
     * "custom" = use Compliance.Module.Housing.Dtos.SearchHousingApplicationsRequestDto.HousingOrgGuid and/or Compliance.Module.Housing.Dtos.SearchHousingApplicationsRequestDto.CreatedByGuid.
     * @param housingOrgGuid Filter by housing org (used when QuickFilter is "custom").
     * @param createdByGuid Filter by application creator (used when QuickFilter is "custom").
     * @param statuses Statuses to include. When empty or null, no status filter is applied.
     * Archived applications are controlled by Compliance.Module.Housing.Dtos.SearchHousingApplicationsRequestDto.IncludeArchived.
     * @param scenarioStatuses Scenario statuses to include.
     * @param includeArchived Whether to include archived applications.
     * @param ignoreFilters When true, only the text search is applied and all other filters are ignored.
     * Matches the "Search All" UX pattern.
     * @param pageNumber
     * @param pageSize
     * @returns SearchVacancyApplicationsResponseDto OK
     * @throws ApiError
     */
    public searchVacancyApplications(
        search?: string,
        nameSearch?: string,
        appNumberSearch?: string,
        emailSearch?: string,
        phoneSearch?: string,
        quickFilter?: string,
        housingOrgGuid?: string,
        createdByGuid?: string,
        statuses?: Array<HousingApplicationStatus>,
        scenarioStatuses?: Array<HousingIntakeScenarioStatus>,
        includeArchived?: boolean,
        ignoreFilters?: boolean,
        pageNumber?: number,
        pageSize?: number,
    ): CancelablePromise<SearchVacancyApplicationsResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/SearchVacancyApplications',
            query: {
                'Search': search,
                'NameSearch': nameSearch,
                'AppNumberSearch': appNumberSearch,
                'EmailSearch': emailSearch,
                'PhoneSearch': phoneSearch,
                'QuickFilter': quickFilter,
                'HousingOrgGuid': housingOrgGuid,
                'CreatedByGuid': createdByGuid,
                'Statuses': statuses,
                'ScenarioStatuses': scenarioStatuses,
                'IncludeArchived': includeArchived,
                'IgnoreFilters': ignoreFilters,
                'PageNumber': pageNumber,
                'PageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all the housing applications created by the user.
     * @param sysOrgGuid
     * @returns HousingApplication OK
     * @throws ApiError
     */
    public getMyHousingApplications(
        sysOrgGuid: string,
    ): CancelablePromise<Array<HousingApplication>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/{sysOrgGuid}/GetMyHousingApplications',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get on-hold housing applications with their most recent on-hold contact activity.
     * Query strategy:
     * 1. Filter housing applications: org, Status == OnHold, archive, text search
     * 2. Join to ContactActivities via EntityGuid, then to Workflows via WorkflowGuid
     * where Workflow.Status == "AppOnHold"
     * 3. Apply assignment filters (AssignedTo / CreatedBy) on the most recent activity
     * (skipped when ignoreFilters == true)
     * 4. Apply date range filter on the most recent activity's CreatedAt or DueDate
     * (skipped when ignoreFilters == true)
     * 5. Paginate
     * 6. Compute total activity count via HousingApplicationPersons → Person → ContactActivity
     * 7. Resolve usernames server-side
     * @param sysOrgGuid
     * @param assignedToUserGuids
     * @param createdByUserGuids
     * @param includeArchived
     * @param applicantNameSearch
     * @param coApplicantNameSearch
     * @param applicationNumberSearch
     * @param emailSearch
     * @param phoneSearch
     * @param idSearch
     * @param dateFrom
     * @param dateTo
     * @param dateField
     * @param ignoreFilters
     * @param pageNumber
     * @param pageSize
     * @returns GetHousingApplicationsWithActivitiesResponseDto OK
     * @throws ApiError
     */
    public getApiHousingHousingApplicationWithActivities(
        sysOrgGuid: string,
        assignedToUserGuids?: Array<string>,
        createdByUserGuids?: Array<string>,
        includeArchived?: boolean,
        applicantNameSearch?: string,
        coApplicantNameSearch?: string,
        applicationNumberSearch?: string,
        emailSearch?: string,
        phoneSearch?: string,
        idSearch?: string,
        dateFrom?: string,
        dateTo?: string,
        dateField?: string,
        ignoreFilters?: boolean,
        pageNumber?: number,
        pageSize?: number,
    ): CancelablePromise<GetHousingApplicationsWithActivitiesResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/{sysOrgGuid}/with-activities',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            query: {
                'AssignedToUserGuids': assignedToUserGuids,
                'CreatedByUserGuids': createdByUserGuids,
                'IncludeArchived': includeArchived,
                'ApplicantNameSearch': applicantNameSearch,
                'CoApplicantNameSearch': coApplicantNameSearch,
                'ApplicationNumberSearch': applicationNumberSearch,
                'EmailSearch': emailSearch,
                'PhoneSearch': phoneSearch,
                'IDSearch': idSearch,
                'DateFrom': dateFrom,
                'DateTo': dateTo,
                'DateField': dateField,
                'IgnoreFilters': ignoreFilters,
                'PageNumber': pageNumber,
                'PageSize': pageSize,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a housing application by its id.
     * @param housingApplicationGuid The id of the housing application
     * @returns HousingApplication OK
     * @throws ApiError
     */
    public getHousingApplication(
        housingApplicationGuid: string,
    ): CancelablePromise<HousingApplication> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/GetHousingApplication',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a housing application by its entity guid.
     * @param entityGuid The entity guid of the housing application
     * @returns HousingApplication OK
     * @throws ApiError
     */
    public getHousingApplicationByEntityGuid(
        entityGuid: string,
    ): CancelablePromise<HousingApplication> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/by-entityguid/{entityGuid}/GetHousingApplicationByEntityGuid',
            path: {
                'entityGuid': entityGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get the lightweight list DTO for a single housing application by its id.
     * Used to refresh a single row in list pages without reloading the entire list.
     * @param housingApplicationGuid The id of the housing application
     * @returns HousingApplicationDto OK
     * @throws ApiError
     */
    public getHousingApplicationForList(
        housingApplicationGuid: string,
    ): CancelablePromise<HousingApplicationDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/GetHousingApplicationForList',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new housing application.
     * @param sysOrgGuid
     * @param applicationSource
     * @param isTracked
     * @returns HousingApplicationDto OK
     * @throws ApiError
     */
    public createHousingApplication(
        sysOrgGuid: string,
        applicationSource: HousingApplicationSource,
        isTracked: boolean = true,
    ): CancelablePromise<HousingApplicationDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingApplication/{sysOrgGuid}/{applicationSource}/{isTracked}/CreateHousingApplication',
            path: {
                'sysOrgGuid': sysOrgGuid,
                'applicationSource': applicationSource,
                'isTracked': isTracked,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Change the something in an application.  Usually just one thing at a time.
     * Should not be called unless a change is actually being made.
     * If other attributes need to be changed, they can be added to the DTO and processed here.
     * @param housingApplicationGuid
     * @param requestBody
     * @returns HousingApplicationDto OK
     * @throws ApiError
     */
    public updateHousingApplication(
        housingApplicationGuid: string,
        requestBody?: UpdateHousingApplicationRequestDto,
    ): CancelablePromise<HousingApplicationDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/UpdateHousingApplication',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update the SiteResults. Okay if no changes are made.
     * @param housingApplicationGuid
     * @param isRecalculation When true, merges eligibility changes (add/remove sites)
     * while preserving existing Preferred selections. When false, applies explicit user selections as-is.
     * @param requestBody
     * @returns HousingApplicationDto OK
     * @throws ApiError
     */
    public updateSiteResults(
        housingApplicationGuid: string,
        isRecalculation: boolean = false,
        requestBody?: Array<HousingSiteResult>,
    ): CancelablePromise<HousingApplicationDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/UpdateSiteResults',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            query: {
                'isRecalculation': isRecalculation,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Submits the housing application by setting all form responses to "Submitted",
     * then advancing the linked workflow from "Draft" to "ReadyForReview".
     * The workflow status change cascades to update the housing application status
     * via Compliance.Module.Housing.Services.HousingApplicationWorkflowStatusService (single source of truth).
     * @param housingApplicationGuid The id of the housing application
     * @returns HousingApplicationDto OK
     * @throws ApiError
     */
    public submitHousingApplication(
        housingApplicationGuid: string,
    ): CancelablePromise<HousingApplicationDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/SubmitHousingApplication',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Change the status of the application.
     * @param housingApplicationGuid The id of the housing application
     * @param status New status
     * @returns HousingApplicationDto OK
     * @throws ApiError
     */
    public setStatus(
        housingApplicationGuid: string,
        status: HousingApplicationStatus,
    ): CancelablePromise<HousingApplicationDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/{status}/SetStatus',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
                'status': status,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all the forms that belong to an application by the application guid.
     * @param applicationGuid
     * @returns FormResponseDto OK
     * @throws ApiError
     */
    public getResponses(
        applicationGuid: string,
    ): CancelablePromise<Array<FormResponseDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/{applicationGuid}/GetResponses',
            path: {
                'applicationGuid': applicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all people linked to a housing application through its entity and workflows.
     * People are Entity records backed by a Person table row, linked to the application's
     * workflows via the LinkedEntitiesInWorkflow join table.
     * @param housingApplicationGuid When guidType is `"HousingApplication"` (default), this is
     * the housing application GUID. When guidType is `"Entity"`,
     * this is the entity GUID of the application directly.
     * @param guidType `"HousingApplication"` (default) or `"Entity"`.
     * @returns LinkedPersonDto OK
     * @throws ApiError
     */
    public getLinkedPeople(
        housingApplicationGuid: string,
        guidType: string = 'HousingApplication',
    ): CancelablePromise<Array<LinkedPersonDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/GetLinkedPeople',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            query: {
                'guidType': guidType,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all data needed to populate the Housing Application drawer in a single call.
     * Combines: GetHousingApplication, GetFinderInput (override), GetResponses,
     * GetLinkedPeople, and GetLinkedWorkflows.
     * @param housingApplicationGuid
     * @returns HousingApplicationDrawerDataDto OK
     * @throws ApiError
     */
    public getDrawerData(
        housingApplicationGuid: string,
    ): CancelablePromise<HousingApplicationDrawerDataDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/GetDrawerData',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new workflow instance for a housing application by application guid + workflow definition name.
     * Resolves the application's entity server-side so callers don't need to know entity guids.
     * TODO: replace workflowDefinitionName string with a typed enum once the set of supported workflows is known.
     * @param housingApplicationGuid
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public createWorkflowForApplication(
        housingApplicationGuid: string,
        requestBody: CreateWorkflowForApplicationRequest,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/CreateWorkflowForApplication',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new workflow instance for the given workflow definition and link it to the specified entities.
     * @param requestBody The request containing housing application entity GUID, person entity GUID, and workflow definition name.
     * @returns string OK
     * @throws ApiError
     */
    public createWorkflow(
        requestBody?: CreateWorkflowRequest,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingApplication/CreateWorkflow',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Set the primary contact for a housing application. Clears any existing primary contact first.
     * @param housingApplicationGuid
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public setPrimaryContact(
        housingApplicationGuid: string,
        requestBody: SetPrimaryContactRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingApplication/{housingApplicationGuid}/SetPrimaryContact',
            path: {
                'housingApplicationGuid': housingApplicationGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
